
import _ from 'lodash';
/*svjul17 start*/
import { useRef } from "react";
/*svjul17 end*/

import CliTerrainLocationSVPriceListView from '../../cliterrain/CliTerrainLocationSVPriceListView'

import MotelTerrain from '../../terrain/MotelTerrain'
//import FacetBar from '../../esfind/FacetBar'
import CliSJScroll from './cliSJScroll'
import TerrainStars from '../../terrain/TerrainStars'
import { Link } from "react-router-dom"
/*sjmar6*/
import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner';
/*sjmar6  end*/

import SJCarousel     from "../../../views/SJCarousel";
import SJCarouselDyna from "../../../views/SJCarouselDyna";

import CliDetailContainer from './cliDetail'
import { CliSearchBarBusCom, SojSearchBarBusCom, FacetBarBusCom } from '../../../containers'

import { SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_NOTCAROUSEL_VIEW } from '../../../constants'
import { Icon, Button, Row, Col, Badge } from 'antd';
/*
   import TerrainLocationSVPriceListView from '../../terrain/TerrainLocationSVPriceListView'
    import TerrainLocationListView from '../../terrain/TerrainLocationListView'
 */
import '../../../css/svlist_styles.css'
//import '../../../css/svsr_styles.css'
//import CliSearchBar from '../../clifind/CliSearchBar';
import { v4 as uuidv4 } from 'uuid';
import history from "../../../history"




const React = require('react')


const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
);

const HeartIcon = props => <Icon component={HeartSvg} {...props} />;


class CliSearchBoardContainer extends React.Component {

    sjSHIPofferselectparent(valuesChild,soj_rate_key ){
        let me = this
     
      let spaceKey = valuesChild['spaceKey']
     
      const { cookies } = this.props;
     
      if(cookies){
          let sjcookoffer_o = null
          
          if(valuesChild ){
                
            let sjcookoffer_val = {}
            
              
              let svcustProfile_newcustomer = {
                "customerId": -6,
                "addressId":-1
            }
            
            //room selection is first room . UI screen for roomtype selection needed
            let svvc = {}
            let asset = valuesChild.offer
            let obroom = {
                "code":asset.code,
                "excursionId":asset.excursionId,
                "name":asset.itineraryTitle,
                rates: []
            }
            let cliRateOb = {
                rateKey : asset.excursionId,
                fromPrice : asset.exTrip.fromPrice,
                fromPriceCurrency: asset.exTrip.fromPriceCurrency,
                id: asset.exTrip.id
            }
            obroom.rates.push(cliRateOb)
            
             //let ratekey = asset.rates[0].rateKey 
             svvc.rateKey = asset.excursionId
             svvc.code = valuesChild.offer.excursionId
             svvc.excursionId = valuesChild.offer.excursionId
             svvc.reviews =  11
             svvc.room = obroom
             svvc.svrate= asset.exTrip.fromPrice
             
             svvc.svcustProfile = svcustProfile_newcustomer

           

             if(!valuesChild['svcustProfile']){
                valuesChild['svcustProfile'] = svcustProfile_newcustomer
             }

             let svaluesChild = JSON.stringify(svvc)
            
             let size = svaluesChild.length
             
           
             
              let sjcrCook = {

              }

            
              try{
                 
                cookies.set('sccook', svaluesChild, { path: '/' });

              }catch(error){
                console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')
   
                   console.log(error)}
             

              let m_offer = cookies.get('sccook')
              
              let my_data_sjtoffee ={
                "customerId": valuesChild['svcustProfile']['customerId'] ,
                "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
                "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
            } 
            my_data_sjtoffee.sjcook = svaluesChild
            
            let expsessid_svt_s =  cookies.get('svabodeclientguest')
            
            
            let m_svt = expsessid_svt_s
            if(m_svt != null){
                my_data_sjtoffee['svt'] = m_svt
            }
           
              
           
            const udob ={
                "svcid": -2,
                "soj_rate_key":valuesChild.offer.exTrip.fromPrice,
                "code": valuesChild.offer.excursionId ,
                "excursionId": valuesChild.offer.excursionId ,
                "room": "r1"
                
            
            }

          
            _.delay(()=>{
                
                 const { soj_rate_key} = udob
                 const { excursionId} = udob
                 // inetcruises/shredbook/119
                 let surl = `/inetcruises/crredbook/${excursionId}`
               
               /*svmar19 start */
               history.push(`/inetcruises/crredbook/${excursionId}`)
               
               /*svamy26mon  passing id and spaceKey to ShyReserveWithSearchPage wich calls SJReview*/
                   }, 400, udob);

            // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)
  
          }else{
              console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer START')
   
          }
          

      }
    
    }
    //sjjul14 start
  
   //sjjul14 start
sjcruiseselectparent(valuesChild,soj_rate_key ){
    let me = this
  
  let spaceKey = valuesChild['spaceKey']
 
  const { cookies } = this.props;
 
  if(cookies){
      let sjcookoffer_o = null
      console.log('********OCT25**************** sv  OCT28 2 COOKIES SET sjcookoffer START')

      if(valuesChild ){
            console.log('********NOV19**************** sv START ')
        let sjcookoffer_val = {}
        
          
          let svcustProfile_newcustomer = {
            "customerId": -6,
            "addressId":-1
        }
        //room selection is first room . UI screen for roomtype selection needed
        let svvc = {}
        let asset = valuesChild.offer
       
        const {departurePortCode, id, excursionId} = valuesChild.offer
       
       
       
        let obroom = {
            "code":asset.id,
            "excursionId" : excursionId,
            "name":asset.departurePortCode,
            rates: []
        }
        obroom.rates.push(departurePortCode)

       

         let ratekey = asset.id 
         svvc.rateKey = id
         svvc.code =asset.id
         svvc.reviews =''
         svvc.room = obroom
         svvc.svrate= asset.id
        // svvc.svrate= asset.exTrip
        
         svvc.svcustProfile = svcustProfile_newcustomer
         if(!valuesChild['svcustProfile']){
            valuesChild['svcustProfile'] = svcustProfile_newcustomer
         }

         let svaluesChild = JSON.stringify(svvc)
         let size = svaluesChild.length
         
         
          

        
          try{
            
            cookies.set('sccook', svaluesChild, { path: '/' });

          }catch(error){
            console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')

               console.log(error)}
         

          let m_offer = cookies.get('sccook')
          
          let my_data_sjtoffee ={
            "customerId": valuesChild['svcustProfile']['customerId'] ,
            "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
            "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
        } 
        my_data_sjtoffee.sjcook = svaluesChild
       
        let expsessid_svt_s =  cookies.get('svabodeclientguest')
        
        
        let m_svt = expsessid_svt_s
        if(m_svt != null){
            my_data_sjtoffee['svt'] = m_svt
        }
        
          
       
        const udob ={
            "svcid": -2,
            "soj_rate_key":id,
            "code": id ,
            "excursionId" : excursionId,
            "room": obroom
            
        
        }

      
        _.delay(()=>{
            
            
             const { soj_rate_key} = udob
             
             const { code, excursionId} = udob
            
             let surl = `/inetcruises/svredcruise/${code}`
          
            history.push(`/inetcruises/svredcruise/${excursionId}`)
            
               }, 400, udob);

        // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)

      }else{
          console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer START')

      }
      

  }

}
    constructor(props) {
        super(props)
        let me = this
        this.getCarouselOrPhoto = this.getCarouselOrPhoto.bind(me)
        this.getExDetailItins = this.getExDetailItins.bind(me)
        /*sjmar6y25*/
        this.closecbParent = this.closecbParent.bind(this)
        this.getBoardBodyContainer_cr = this.getBoardBodyContainer_cr.bind(me)
        /*svjul17 */
       /* this.getContainer_stateroom = this.getContainer_stateroom.bind(me);*/
        this.sjfarselectparent = this.sjfarselectparent.bind(me)
        /*svjul17 end */
        /*svDec19 */
        this.sjcruiseselectparent = this.sjcruiseselectparent.bind(me)
        this.sjSHIPofferselectparent = this.sjSHIPofferselectparent.bind(me)

        /*
        this.state = {  
           
            
            filters: {
                checkedParkingLabel:'Parking',
                checkedParking:true,
                disabledParking:false,

                checkedWifiLabel:'Wifi',
                checkedWifi:true,
                disabledWifi:false,

                checkedRestaurantLabel:'Restaurant',
                checkedRestaurant:true,
                disabledRestaurant:false,

                checkedPetfriendlyabel:'pet Friendlly',
                checkedPetfriendly:true,
                disabledPetfriendly:false,

                checkedRoomserviceLabel:'Room Service',
                checkedRoomservice:true,
                disabledRoomservice:false,

                checkedFrontdeskLabel:'24 Hours Front Desk',
                checkedFrontdesk:true,
                disabledFrontdesk:false,

                checkedFitnessLabel:'Fitness Center',
                checkedFitness:true,
                disabledFitness:false,

                checkedNonsmokingLabel:'Non Smoking',
                checkedNonsmoking:true,
                disabledNonsmoking:false,

                checkedShuttleLabel:'Airport Shuttle',
                checkedShuttle:true,
                disabledShuttle:false,

                checkedFamilyroomsLabel:'Family Room',
                checkedFamilyrooms:true,
                disabledFamilyrooms:false,

                checkedSpaLabel:'Spa',
                checkedSpa:true,
                disabledSpa:false,

                checkedEvchargingLabel:'Electric Vehicle(EV) Charging',
                checkedEvcharging:true,
                disabledEvcharging:false,

                checkedWheelchairLabel:'Wheel Chair Accessibility',
                checkedWheelchair:true,
                disabledFWheelchair:false



            }
            
        }
        
        this.onChangeCbParking = this.onChangeCbParking.bind(me)
        */
        this.getAppDetails = this.getAppDetails.bind(this)
        this.getAppDetailsMyReservation = this.getAppDetailsMyReservation.bind(this)

        this.getMyHtml = this.getMyHtml.bind(this)
        this.getReserveHtmlButton = this.getReserveHtmlButton.bind(this)
        this.svsojourns = []
        this.title = 'PROD-NON-PROD Symmetry'
        this.getHotelAmenityList = this.getHotelAmenityList.bind(me)
        this.getChildContainers = this.getChildContainers.bind(me)
        this.getChildContainersList = this.getChildContainersList.bind(me)
        this.getBedroomDetails = this.getBedroomDetails.bind(me)
        this.deleteTaskCurryParams = this.deleteTaskCurryParams.bind(this)

        this.starBody = this.starBody.bind(this)
        this.getExBottles = this.getExBottles.bind(me)
    }
    starBody(o) {
        let svrstars = {
            "sv_rating_no": o.avg_stars_rating ? o.avg_stars_rating : 5,
            "color": "#e8a01899"
        }
        return (<TerrainStars svrstars={svrstars} ></TerrainStars>)

    }
    /*
    onChangeCbParking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedParking'] =e.target.checked

        this.setState({filters:f} )

    }

    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbRestaurant=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRestaurant =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbPetfriendly=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPetfriendly =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbRoomservice=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRoomservice =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbFrontdesk=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFrontdesk =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbFitness=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFitness =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbNonsmoking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedNonsmoking =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbShuttle=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedShuttle =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbFamilyrooms=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFamilyrooms =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbSpa=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedSpa =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbEvcharging=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedEvcharging =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbWheelchair=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWheelchair =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbPool=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPool =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

        this.setState({filters:f} )

    }
    */
    deleteTaskCurryParams = (param1, ctx) => (event) => {
        console.log(param1)
        let me = ctx
        me.currentSelection = param1.sojourncode
        console.log('sv delete task curry')
        console.log(param1.sojourncode)
        //me.props.svWrappedDeleteTaskActionCreator(param1.id)
    }
    getBedroomDetails = (s, ctx) => (event) => {

        const det = 'Ssandara Queen Room with '
        console.log('sv**currryy' + s)
        s = (s ? s : '2')
        if (s == '4') {
            return det + '4' + 'Rooms'
        } else {
            return det + s + 'Rooms'
        }

    }
    getAppDetailsMyReservation(paramQSpaceId, svcustProfile) {
        console.log('caall getAppDetailsMyReservation', paramQSpaceId, svcustProfile)

        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
        this.props.cliAndImagesSV("svpromo")

    }
    /*svmar14 start*/ 
    /*
    getAppDetails_orgsvgood(paramQ) {

        // this.props.getSoDetails("mancreek")
        this.props.cliAndImagesSV("svpromo")
        // this.props.cliAndImagesCruise("mancreek")

    }
    */
    getAppDetails(paramQ){
        
        // this.props.getSoDetails("mancreek")
 
       // this.props.flyAndImagesSV("mancreek")
 
       let sojPostRq = {
        "docId": ["5"],
        "hsetname": "CARNIVAL"
      }
      /*svmar14 end*/ 
    // this.props.flyAndImagesSV(sojPostRq)
    this.props.cliCountryCodeSV(sojPostRq)
        
        
     }
    componentWillMount() {
        console.log('=---json')
        const { cookies } = this.props;

        if (cookies) {
            let sguestchild = uuidv4()
            cookies.set('sccook', sguestchild, { path: '/' });
        }

        let svsojourns = [

            {
                "name": "3",
                "id": 3,
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "4",
                "id": 4,
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
        console.log('**sv sohourns got from service ********')
        console.log(svsojourns)
        /* this.state = {
                    tasks: svtasks
            }*/
        //sv step1 dipatch action  dispatch is warpper with actiobcreateer by redux
        //sv step2 reduce gives you new state that is available as props to render method
        console.log('sv--tasks')
        this.svsojourns = svsojourns
        var ar = svsojourns;
        //this.props.svWrappedfetchSVESSearchActionCreator(ar)
        this.getAppDetails('mancreek')




    }

    getMyHtml() {
        let ar = this.state.my_data;

        console.log(this.state)
        console.log(ar);
        const my_data = this.state.my_data;
        return my_data.map(o => {
            console.log(o)
            return (<li>{o.name}</li>)
        });
    }

    getReserveHtmlButton(o, customerId) {
        if (customerId > 0) {
            return (<Button style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" ><Link to={`/myaccountSV/${customerId}/reservesvCustNew/${o.space_key}`}> MyReserve  </Link></Button>)


        } else {

            return (<Button style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" ><Link to={`/inetabode/svredbook/${o.space_key}`}> Reserve  </Link></Button>)

        }

    }
    getHotelAmenityList(ar) {


        ar = ar || []
        return ar.map((v, idx) => {
            if (v.toLocaleLowerCase() == "swimming beach") {
                return (<span style={{ fontSize: "14px" }} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{ paddingLeft: "10px" }}>{v}</text></span>)

            } else if (v.toLocaleLowerCase() == "tennis") {
                return (<span style={{ fontSize: "14px" }} > <Icon style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{ paddingLeft: "10px" }}>{v}</text></span>)


            } else if (v.toLocaleLowerCase() == "water") {
                return (<span style={{ fontSize: "14px" }} > <Icon style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{ paddingLeft: "10px" }}>{v}</text></span>)


            } else {

                return (<span style={{ fontSize: "14px" }} > <Icon style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{ paddingLeft: "10px" }}>{v}</text></span>)

            }
        })



    }

    getChildContainers() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
        if (this.props.sojourns && (this.props.sojourns.length > 0)) {
            sojourns = this.props.sojourns

            console.log('sv******************this.props')
            console.log(this.props)

            console.log('sv******************this.props....')
        }
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
        }
        /*
        if (this.props.loading) {
            return <Loader type='spinner' />
        } else if (this.props.error) {
            return <ErrorWidget error={this.props.error} />
        }
        */
        return (
            <div>


                <div className="box-outer-listhotels">
                    <div className="box-left-listhotels">
                        <p>

                            <text className="f24" >SV Cambria Hotel Oraland </text>
                            <span className="f12" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>

                        </p>

                    </div>

                    <div className="box-right-listhotels">

                        <p>
                            <text className="f19">Excellent </text>
                            <text className="f12 d-block"  >12345 reviews </text>
                            <span className="f12 sv-hide" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>

                        </p>


                    </div>
                </div>


                <div className="box-outer-listhotels">
                    <div className="box-left-listhotels">
                        <p>

                            <text className="f19"> Standard Queen Room With two Queen Rooms & shower </text>
                            <text className="f12"> 2 Queen Beds </text>

                        </p>

                    </div>

                    <div className="box-right-listhotels">

                        <p>
                            <text className="f19">1night, 2days </text>
                            <text className="f22 d-block">$116 </text>


                        </p>

                    </div>
                </div>
                <div className="box-outer-listhotels">
                    <div className="box-left-listhotels">
                        <p>

                            <text className="f19"> Only 8  Rooms left </text>


                        </p>

                    </div>

                    <div className="box-right-listhotels">

                        <p>



                        </p>

                    </div>
                </div>

            </div>


        )
    }

    getChildContainersOld() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
        if (this.props.sojourns && (this.props.sojourns.length > 0)) {
            sojourns = this.props.sojourns

            console.log('sv******************this.props')
            console.log(this.props)

            console.log('sv******************this.props....')
        }
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
        }
        /*
        if (this.props.loading) {
            return <Loader type='spinner' />
        } else if (this.props.error) {
            return <ErrorWidget error={this.props.error} />
        }
        */
        return (
            <div>

                <a target="_blank" rel="noopener noreferrer" href="https://www.booking.com/hotel/us/san-diego-del-mar.html?label=gen173nr-1FCAEoggI46AdIM1gEaIkCiAEBmAExuAEYyAEP2AEB6AEB-AECiAIBqAIEuAKNu_CxBsACAdICJGY4NTJhN2NkLTkxMmItNDE1Zi04ZGI4LTVjYWRjNDU2N2M3NNgCBeACAQ&amp;aid=304142&amp;ucfs=1&amp;arphpl=1&amp;checkin=2024-05-24&amp;checkout=2024-06-07&amp;dest_id=20015725&amp;dest_type=city&amp;group_adults=2&amp;req_adults=2&amp;no_rooms=1&amp;group_children=0&amp;req_children=0&amp;hpos=1&amp;hapos=1&amp;sr_order=popularity&amp;srpvid=025e05dca08401b2&amp;srepoch=1715217706&amp;all_sr_blocks=26285401_246425381_0_42_0&amp;highlighted_blocks=26285401_246425381_0_42_0&amp;matching_block_id=26285401_246425381_0_42_0&amp;sr_pri_blocks=26285401_246425381_0_42_0__250600&amp;from_sustainable_property_sr=1&amp;from=searchresults&amp;map=1" className="a83ed08757 f88a5204c2 a1ae279108 b98133fb50"><span><span className="aee5343fdb def9bc142a" data-testid="address">Carmel Valley, San Diego</span><span className="aee5343fdb def9bc142a">Show on map</span></span></a><span className="aee5343fdb"><span className="f419a93f12"><span aria-expanded="false" data-testid="distance">16.1 miles from downtown</span></span></span><span className="aee5343fdb"><span className="f419a93f12"><span aria-expanded="false">Beach Nearby</span></span></span>

                {

                    my_data.map(o => {
                        console.log(o)
                        return (<li>{o.sojourn_name}</li>)
                    })
                }
            </div>


        )
    }



    render() {
        const lastestUpdateDate = 'Data Refresh Daily'

        /*
        const { title, sojourns} = this
 
         const getMyHtml = () => {
             return this.props.sojourns.map(o => {
                 console.log(o)
                 return (<li>{o.sojourncode}</li>)
             });
         }
     
         const getMyData = () => {
             let arso = sojourns
             console.log("dino data");
             console.log(sojourns);
             console.log("end");
             return arso;TerrainLocationSVPriceListView.js
         }
        */
        console.log('***sv dec16')
        console.log(this.props)
        const { cookies, cruisesearch } = this.props;
        const {my_data_meta} = this.props.cruisesearch
        console.log('***sv dec16 B cruisesearch')
        console.log(cruisesearch)
        /*
        let svcookoffer_val = "yyXX"
        console.log('********OCT25**************** COOKIES SET svcookoffer START')

        if (cookies) {
            cookies.set('svcookoffer', svcookoffer_val, { path: '/' });
        } else {
            console.log('********OCT25****************FAILED to set cookies bull *** COOKIES SET svcookoffer START')

        }
*/

        return (
            <noop>
                    
                     <div className="col-md-12">



                        <MotelTerrain lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersList()}></MotelTerrain>
                    </div>
            </noop>

           
        )

    }


    getChildContainersList_hw() {

        /*
                const {
                checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
                disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
                checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
                checkedParking,checkedParkingLabel,disabledParking
        
        
                } = this.state.filters
                */
        const size = 'small'
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let customerId = -1
        let svCustomerId = -1
        const { dataProfile, svcustProfile } = this.props
        if (svcustProfile && svcustProfile.customerId > 0) {
            customerId = svcustProfile.customerId
            svCustomerId = customerId
            console.log('myreservationSpace')
        } else {
            console.log('internet userSpace')
        }
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        /*
        if (this.props.svessearch.data && (this.props.svessearch.data.length > 0)) {
            data = this.props.svessearch.data
        }
        if (this.props.svessearch.sojourns && (this.props.svessearch.sojourns.length > 0)) {
            sojourns = this.props.svessearch.sojourns
 
            console.log('sv******************this.props')
            console.log(this.props)
 
            console.log('sv******************this.props....')
        }
        if (this.props.svessearch && this.props.svessearch.my_data && (this.props.svessearch.my_data.length > 0)) {
            my_data = this.props.svessearch.my_data
        }else if(this.props.my_data && (this.props.my_data.length > 0)){
            my_data = this.props.my_data
        }
 
        const {svessearch, locationDataView} = this.props
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
        console.log(this.props)
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
        */
        let testimonyO = {
            avg_stars_rating: 5
        }
        return (
            <div className="svr-det-pageWrapper">
                <header className="svr-header1">
                    <h1><span><text style={{ color: '#f0d8a9' }}>Choose Your Cruise</text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                </header>
                {/*  
                            <SojSearchBarBusCom />
                            
                           */}

                <div className="svr-spacelist-contentWrapper">
                    <article className="main-listcruises">
                        <div>Cruise List Component here</div>
                        <div className="svr-clislist-container">
                            <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                <div className="svr-clilist-boxr-1">
                                    <div className="gallery">
                                        <figure style={{ width: '360px', height: '200px' }}>
                                            <span>	<Link to={`/svredsojourn`} >

                                                <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                            </Link> </span>

                                        </figure>
                                    </div>
                                    <div className="svr-clilist-boxr-1">

                                        <p>
                                            <text className="svr-ex-ship">Norwegian bliss </text>
                                            <text className="svr-ex-name">4-Day Bahamas Round-Trip Miami: Great Stirrup Cay & Nassau </text>
                                            <text className="ter-l2 svr-ex-location">O Miami rlando</text>

                                        </p>


                                    </div>
                                    <div className="svr-clilist-boxr-1">

                                        <p>
                                            <text className="svr-ex-old-price">$558 </text>
                                            <text className="svr-ex-price">$329 </text>
                                            <text className="svr-ex-taxes">includes, taxes and fewa</text>

                                        </p>


                                    </div>
                                    <div className="svr-clilist-boxr-1">

                                        <p>
                                            <text className="svr-ex-itn">See Iineraryr </text>

                                        </p>


                                    </div>



                                </div>


                            </div>
                            <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                <div className="svr-clilist-boxr-1">
                                    <div className="gallery">
                                        <figure style={{ width: '360px', height: '200px' }}>
                                            <span>	<Link to={`/svredsojourn`} >

                                                <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                            </Link> </span>

                                        </figure>
                                    </div>
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                                <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                    away</text></span>

                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">Excellent </text>
                                                <text className="f12 d-block">12345 reviews </text>
                                            </p>
                                        </div>
                                    </div>


                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                                <text className="f12  d-block"> 2 Queen Beds </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">1night, 2days </text>
                                                <text className="svr-hotel-price d-block">$116 </text>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="svr-hotel-avail">
                                                <text className="f19"> Only 8 Rooms left </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p>

                                            </p>
                                        </div>
                                    </div>


                                </div>


                            </div>
                            <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                <div className="svr-clilist-boxr-1">
                                    <div className="gallery">
                                        <figure style={{ width: '360px', height: '200px' }}>
                                            <span>	<Link to={`/svredsojourn`} >

                                                <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                            </Link> </span>

                                        </figure>
                                    </div>
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                                <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                    away</text></span>

                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">Excellent </text>
                                                <text className="f12 d-block">12345 reviews </text>
                                            </p>
                                        </div>
                                    </div>


                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                                <text className="f12  d-block"> 2 Queen Beds </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">1night, 2days </text>
                                                <text className="svr-hotel-price d-block">$116 </text>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="svr-hotel-avail">
                                                <text className="f19"> Only 8 Rooms left </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p>

                                            </p>
                                        </div>
                                    </div>


                                </div>


                            </div>
                            <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                <div className="svr-clilist-boxr-1">
                                    <div className="gallery">
                                        <figure style={{ width: '360px', height: '200px' }}>
                                            <span>	<Link to={`/svredsojourn`} >

                                                <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                            </Link> </span>

                                        </figure>
                                    </div>
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                                <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                    away</text></span>

                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">Excellent </text>
                                                <text className="f12 d-block">12345 reviews </text>
                                            </p>
                                        </div>
                                    </div>


                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                                <text className="f12  d-block"> 2 Queen Beds </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">1night, 2days </text>
                                                <text className="svr-hotel-price d-block">$116 </text>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="svr-hotel-avail">
                                                <text className="f19"> Only 8 Rooms left </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p>

                                            </p>
                                        </div>
                                    </div>


                                </div>


                            </div>
                            <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                <div className="svr-clilist-boxr-1">
                                    <div className="gallery">
                                        <figure style={{ width: '360px', height: '200px' }}>
                                            <span>	<Link to={`/svredsojourn`} >

                                                <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                            </Link> </span>

                                        </figure>
                                    </div>
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                                <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                    away</text></span>

                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">Excellent </text>
                                                <text className="f12 d-block">12345 reviews </text>
                                            </p>
                                        </div>
                                    </div>


                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                                <text className="f12  d-block"> 2 Queen Beds </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">1night, 2days </text>
                                                <text className="svr-hotel-price d-block">$116 </text>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="svr-hotel-avail">
                                                <text className="f19"> Only 8 Rooms left </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p>

                                            </p>
                                        </div>
                                    </div>


                                </div>


                            </div>
                            <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                <div className="svr-clilist-boxr-1">
                                    <div className="gallery">
                                        <figure style={{ width: '360px', height: '200px' }}>
                                            <span>	<Link to={`/svredsojourn`} >

                                                <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                            </Link> </span>

                                        </figure>
                                    </div>
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                                <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                    away</text></span>

                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">Excellent </text>
                                                <text className="f12 d-block">12345 reviews </text>
                                            </p>
                                        </div>
                                    </div>


                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                                <text className="f12  d-block"> 2 Queen Beds </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">1night, 2days </text>
                                                <text className="svr-hotel-price d-block">$116 </text>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="svr-hotel-avail">
                                                <text className="f19"> Only 8 Rooms left </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p>

                                            </p>
                                        </div>
                                    </div>


                                </div>


                            </div>
                            <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                <div className="svr-clilist-boxr-1">
                                    <div className="gallery">
                                        <figure style={{ width: '360px', height: '200px' }}>
                                            <span>	<Link to={`/svredsojourn`} >

                                                <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                            </Link> </span>

                                        </figure>
                                    </div>
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                                <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                    away</text></span>

                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">Excellent </text>
                                                <text className="f12 d-block">12345 reviews </text>
                                            </p>
                                        </div>
                                    </div>


                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                                <text className="f12  d-block"> 2 Queen Beds </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">1night, 2days </text>
                                                <text className="svr-hotel-price d-block">$116 </text>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="svr-hotel-avail">
                                                <text className="f19"> Only 8 Rooms left </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p>

                                            </p>
                                        </div>
                                    </div>


                                </div>


                            </div>
                        </div>
                    </article>




                </div>




                <br />


            </div>

        )
    }
    getCarouselOrPhoto = (o) =>{
        let ar =  o['imgs']
       let roomImgs =ar
       let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
       if(roomImgs && (roomImgs.length > 0)) {
            roomImg = roomImgs[0]
       }

       let photoOnly =  SV_SOJ_NOTCAROUSEL_VIEW ? SV_SOJ_NOTCAROUSEL_VIEW :false
       
       if(photoOnly){
                     return  (
                 <div className="gallery">
                     <figure style={{'marginBottom':'0px'}}>
                     <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                     
                     <img src={`${roomImg}`}  alt="Carpet Grass" />
                     </Link> </span>
                         
                     </figure>
                 </div>)

       }
       //check ar
       if(ar && (ar.length > 2) ){
           let roomImgs = ar.slice(0,6)
         return ( <SJCarouselDyna roomImgs={roomImgs} ></SJCarouselDyna>)

       }else{
           return ( <SJCarousel ></SJCarousel>)
       }

   }
    getExBottles(my_data) {
        const { sjcruiseselectparent,sjfarselectparent,sjSHIPofferselectparent} = this
        let svcustProfile = this.props.svcustProfile
        if(!svcustProfile){
            svcustProfile = {
                customerId: -11
            }
        }
        return my_data.map(o => {
            console.log(o)
            return (
                <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">
                    <div className="svr-clilist-boxr-1">
                    {this.getCarouselOrPhoto(o)}
                    {/*  <SJCarousel ></SJCarousel>*/}
                       
                        {/*  
                        
            <div className="gallery">
                <figure style={{ width: '360px', height: '200px' }}>
                    <span>	<Link to={`/svredsojourn`} >

                        <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                    </Link> </span>

                </figure>
            </div>
             */}
                        <div className="svr-clilist-boxr-1">

                            <p>
                                <text className="svr-ex-ship">Carnival {o.shipCode} </text>
                                <text className="svr-ex-name">{o.itineraryTitle} </text>
                                <text className="ter-l2 svr-ex-location"> {o.departurePortName} </text>

                            </p>


                        </div>
                        <div className="svr-clilist-boxr-1">

                            <p>
                                <text className="svr-ex-old-price">$558 </text>
                                
                                <text className="svr-ex-price">${(o.exTrip.fromPrice > 100) ? o.exTrip.fromPrice : 329} PP USD </text>
                                <text className="svr-ex-old-price">Excursion {o.excursionId} </text>
                                <text className="svr-ex-taxes">includes, taxes and fewa</text>

                            </p>


                        </div>
                        <div className="svr-clilist-boxr-1">
                        <CliTerrainLocationSVPriceListView excursionInfo={o} sjcruiseselectparent= {sjcruiseselectparent} sjfarselectparent= {sjfarselectparent} svcustProfile={svcustProfile} sjSHIPofferselectparent={sjSHIPofferselectparent} ></CliTerrainLocationSVPriceListView>
                            {/* 
                            <CliTerrainLocationSVPriceListView sjcruiseselectparent= {sjcruiseselectparent} svcustProfile={svcustProfile} sjSHIPofferselectparent={sjSHIPofferselectparent} ></CliTerrainLocationSVPriceListView>
                            <SojTerrainLocationSVPriceListView sjofferselectparent= {sjofferselectparent}  priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  svrlocation={svr_location} sjhotelselectparent={sjhotelselectparent} sjprobatecourtselectparent={sjprobatecourtselectparent} ></SojTerrainLocationSVPriceListView>
                            <p>
                                <text className="svr-ex-itn">See Iineraryr </text>

                            </p>
                            */}
                            


                        </div>


                    </div>
                </div>)
        });

    }


    getChildContainersList() {
        const {sjprobatecourtselectparent,sjSHIPofferselectparent,sjcruiseselectparent, sjfarselectparent, svofferMyFlyReservationSelectparent} = this
        const {cliAndImagesSojournMore} = this.props
        let customerId = -1
        let svCustomerId = -1
        const { dataProfile, svcustProfile } = this.props
        console.log('svDec18*********this.props list data')
        console.log(this.props)
        if (svcustProfile && svcustProfile.customerId > 0) {
            customerId = svcustProfile.customerId
            svCustomerId = customerId
            console.log('myreservationSpace')
        } else {
            console.log('internet userSpace')
        }
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = [], my_data_tmp, hasMore = true, ctotal=1
       
        /*
                 my_data = [
            {
                "code": "MI",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-14T00:00:00.000Z",
                    "arrivalDayOfWeek": "Thu",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-07T00:00:00.000Z",
                    "departureDayOfWeek": "Thu",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 0,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_SP_6_Mon",
                "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": true,
                "sailings": null,
                "shipCode": "MI",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            }

        ]
                my_data =[
                    {
                        "code": "MI",
                        "departurePortCode": "SEA",
                        "departurePortName": "Seattle, WA",
                        "dur": 7,
                        "duration": null,
                        "exTrip": {
                            "arrivalDate": "2026-05-14T00:00:00.000Z",
                            "arrivalDayOfWeek": "Thu",
                            "arrivalDayOfWeekFull": null,
                            "arrivalMmmDYyyy": null,
                            "arrivalMmmDdYyyy": null,
                            "departureDate": "2026-05-07T00:00:00.000Z",
                            "departureDayOfWeek": "Thu",
                            "departureDayOfWeekFull": null,
                            "departureMmmDYyyy": null,
                            "departureMmmDdYyyy": null,
                            "embarkPortCode": "SEA",
                            "exSchedule": null,
                            "fromPrice": 0,
                            "fromPriceCurrency": "USD",
                            "leadMetaCode": "IS",
                            "taxesAndFees": 0
                        },
                        "hasExtraValue": true,
                        "id": "GA2_SEA_SP_6_Mon",
                        "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
                        "imageRandomizationInfo": null,
                        "imageSquare": null,
                        "imageUrl": null,
                        "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
                        "itineraryTitleFormatted": null,
                        "itineraryURL": null,
                        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
                        "portsToDisplay": null,
                        "regionCode": "GL",
                        "regionName": null,
                        "roundtrip": true,
                        "sailings": null,
                        "shipCode": "MI",
                        "shipName": null,
                        "specialScoops": null,
                        "stateroomMetaInformation": null,
                        "taxesAndFeesRange": null
                    },
                    {
                        "code": "SP",
                        "departurePortCode": "SEA",
                        "departurePortName": "Seattle, WA",
                        "dur": 7,
                        "duration": null,
                        "exTrip": {
                            "arrivalDate": "2026-05-12T00:00:00.000Z",
                            "arrivalDayOfWeek": "Tue",
                            "arrivalDayOfWeekFull": null,
                            "arrivalMmmDYyyy": null,
                            "arrivalMmmDdYyyy": null,
                            "departureDate": "2026-05-05T00:00:00.000Z",
                            "departureDayOfWeek": "Tue",
                            "departureDayOfWeekFull": null,
                            "departureMmmDYyyy": null,
                            "departureMmmDdYyyy": null,
                            "embarkPortCode": "SEA",
                            "exSchedule": null,
                            "fromPrice": 809,
                            "fromPriceCurrency": "USD",
                            "leadMetaCode": "IS",
                            "taxesAndFees": 0
                        },
                        "hasExtraValue": true,
                        "id": "GA2_SEA_SP_7_Tue_ols",
                        "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalSpirit&format=image",
                        "imageRandomizationInfo": null,
                        "imageSquare": null,
                        "imageUrl": null,
                        "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                        "itineraryTitleFormatted": null,
                        "itineraryURL": null,
                        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/spirit/7-days/ga2?itinportcode=SEA&sailDate=05052026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                        "portsToDisplay": null,
                        "regionCode": "GL",
                        "regionName": null,
                        "roundtrip": false,
                        "sailings": null,
                        "shipCode": "SP",
                        "shipName": null,
                        "specialScoops": null,
                        "stateroomMetaInformation": null,
                        "taxesAndFeesRange": null
                    },
                    {
                        "code": "MI",
                        "departurePortCode": "SEA",
                        "departurePortName": "Seattle, WA",
                        "dur": 7,
                        "duration": null,
                        "exTrip": {
                            "arrivalDate": "2026-05-14T00:00:00.000Z",
                            "arrivalDayOfWeek": "Thu",
                            "arrivalDayOfWeekFull": null,
                            "arrivalMmmDYyyy": null,
                            "arrivalMmmDdYyyy": null,
                            "departureDate": "2026-05-07T00:00:00.000Z",
                            "departureDayOfWeek": "Thu",
                            "departureDayOfWeekFull": null,
                            "departureMmmDYyyy": null,
                            "departureMmmDdYyyy": null,
                            "embarkPortCode": "SEA",
                            "exSchedule": null,
                            "fromPrice": 829,
                            "fromPriceCurrency": "USD",
                            "leadMetaCode": "IS",
                            "taxesAndFees": 0
                        },
                        "hasExtraValue": true,
                        "id": "GA2_SEA_MI_7_Thu",
                        "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalMiracle&format=image",
                        "imageRandomizationInfo": null,
                        "imageSquare": null,
                        "imageUrl": null,
                        "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                        "itineraryTitleFormatted": null,
                        "itineraryURL": null,
                        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&sailDate=05072026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                        "portsToDisplay": null,
                        "regionCode": "GL",
                        "regionName": null,
                        "roundtrip": false,
                        "sailings": null,
                        "shipCode": "MI",
                        "shipName": null,
                        "specialScoops": null,
                        "stateroomMetaInformation": null,
                        "taxesAndFeesRange": null
                    },
                    {
                        "code": "SP",
                        "departurePortCode": "SEA",
                        "departurePortName": "Seattle, WA",
                        "dur": 7,
                        "duration": null,
                        "exTrip": {
                            "arrivalDate": "2026-05-12T00:00:00.000Z",
                            "arrivalDayOfWeek": "Tue",
                            "arrivalDayOfWeekFull": null,
                            "arrivalMmmDYyyy": null,
                            "arrivalMmmDdYyyy": null,
                            "departureDate": "2026-05-05T00:00:00.000Z",
                            "departureDayOfWeek": "Tue",
                            "departureDayOfWeekFull": null,
                            "departureMmmDYyyy": null,
                            "departureMmmDdYyyy": null,
                            "embarkPortCode": "SEA",
                            "exSchedule": null,
                            "fromPrice": 809,
                            "fromPriceCurrency": "USD",
                            "leadMetaCode": "IS",
                            "taxesAndFees": 0
                        },
                        "hasExtraValue": true,
                        "id": "GA2_SEA_SP_7_Tue",
                        "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalSpirit&format=image",
                        "imageRandomizationInfo": null,
                        "imageSquare": null,
                        "imageUrl": null,
                        "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                        "itineraryTitleFormatted": null,
                        "itineraryURL": null,
                        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/spirit/7-days/ga2?itinportcode=SEA&sailDate=05052026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                        "portsToDisplay": null,
                        "regionCode": "GL",
                        "regionName": null,
                        "roundtrip": false,
                        "sailings": null,
                        "shipCode": "SP",
                        "shipName": null,
                        "specialScoops": null,
                        "stateroomMetaInformation": null,
                        "taxesAndFeesRange": null
                    },
                    {
                        "code": "MI",
                        "departurePortCode": "SEA",
                        "departurePortName": "Seattle, WA",
                        "dur": 7,
                        "duration": null,
                        "exTrip": {
                            "arrivalDate": "2026-05-14T00:00:00.000Z",
                            "arrivalDayOfWeek": "Thu",
                            "arrivalDayOfWeekFull": null,
                            "arrivalMmmDYyyy": null,
                            "arrivalMmmDdYyyy": null,
                            "departureDate": "2026-05-07T00:00:00.000Z",
                            "departureDayOfWeek": "Thu",
                            "departureDayOfWeekFull": null,
                            "departureMmmDYyyy": null,
                            "departureMmmDdYyyy": null,
                            "embarkPortCode": "SEA",
                            "exSchedule": null,
                            "fromPrice": 829,
                            "fromPriceCurrency": "USD",
                            "leadMetaCode": "IS",
                            "taxesAndFees": 0
                        },
                        "hasExtraValue": true,
                        "id": "GA2_SEA_MI_7_Thu",
                        "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalMiracle&format=image",
                        "imageRandomizationInfo": null,
                        "imageSquare": null,
                        "imageUrl": null,
                        "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                        "itineraryTitleFormatted": null,
                        "itineraryURL": null,
                        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&sailDate=05072026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                        "portsToDisplay": null,
                        "regionCode": "GL",
                        "regionName": null,
                        "roundtrip": false,
                        "sailings": null,
                        "shipCode": "MI",
                        "shipName": null,
                        "specialScoops": null,
                        "stateroomMetaInformation": null,
                        "taxesAndFeesRange": null
                    },
                    {
                        "code": "MI",
                        "departurePortCode": "SEA",
                        "departurePortName": "Seattle, WA",
                        "dur": 7,
                        "duration": null,
                        "exTrip": {
                            "arrivalDate": "2026-05-14T00:00:00.000Z",
                            "arrivalDayOfWeek": "Thu",
                            "arrivalDayOfWeekFull": null,
                            "arrivalMmmDYyyy": null,
                            "arrivalMmmDdYyyy": null,
                            "departureDate": "2026-05-07T00:00:00.000Z",
                            "departureDayOfWeek": "Thu",
                            "departureDayOfWeekFull": null,
                            "departureMmmDYyyy": null,
                            "departureMmmDdYyyy": null,
                            "embarkPortCode": "SEA",
                            "exSchedule": null,
                            "fromPrice": 0,
                            "fromPriceCurrency": "USD",
                            "leadMetaCode": "IS",
                            "taxesAndFees": 0
                        },
                        "hasExtraValue": true,
                        "id": "GA2_SEA_SP_7_Tue_HW",
                        "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
                        "imageRandomizationInfo": null,
                        "imageSquare": null,
                        "imageUrl": null,
                        "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                        "itineraryTitleFormatted": null,
                        "itineraryURL": null,
                        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
                        "portsToDisplay": null,
                        "regionCode": "GL",
                        "regionName": null,
                        "roundtrip": true,
                        "sailings": null,
                        "shipCode": "MI",
                        "shipName": null,
                        "specialScoops": null,
                        "stateroomMetaInformation": null,
                        "taxesAndFeesRange": null
                    },
                    {
                        "code": "MI",
                        "departurePortCode": "SEA",
                        "departurePortName": "Seattle, WA",
                        "dur": 7,
                        "duration": null,
                        "exTrip": {
                            "arrivalDate": "2026-05-14T00:00:00.000Z",
                            "arrivalDayOfWeek": "Thu",
                            "arrivalDayOfWeekFull": null,
                            "arrivalMmmDYyyy": null,
                            "arrivalMmmDdYyyy": null,
                            "departureDate": "2026-05-07T00:00:00.000Z",
                            "departureDayOfWeek": "Thu",
                            "departureDayOfWeekFull": null,
                            "departureMmmDYyyy": null,
                            "departureMmmDdYyyy": null,
                            "embarkPortCode": "SEA",
                            "exSchedule": null,
                            "fromPrice": 0,
                            "fromPriceCurrency": "USD",
                            "leadMetaCode": "IS",
                            "taxesAndFees": 0
                        },
                        "hasExtraValue": true,
                        "id": "GA2_SEA_SP_6_Mon_HW",
                        "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
                        "imageRandomizationInfo": null,
                        "imageSquare": null,
                        "imageUrl": null,
                        "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
                        "itineraryTitleFormatted": null,
                        "itineraryURL": null,
                        "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
                        "portsToDisplay": null,
                        "regionCode": "GL",
                        "regionName": null,
                        "roundtrip": true,
                        "sailings": null,
                        "shipCode": "MI",
                        "shipName": null,
                        "specialScoops": null,
                        "stateroomMetaInformation": null,
                        "taxesAndFeesRange": null
                    }
                ]
                */
        const { cruisesearch, locationDataView } = this.props
        const svcli_esquery_data = {cruisesearch}
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master DEC19 start')
        console.log(this.props)
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master DEC19 end')

        /*
        if (this.props.svessearch.data && (this.props.svessearch.data.length > 0)) {
            data = this.props.svessearch.data
        }
        if (this.props.svessearch.sojourns && (this.props.svessearch.sojourns.length > 0)) {
            sojourns = this.props.svessearch.sojourns
 
            console.log('sv******************this.props')
            console.log(this.props)
 
            console.log('sv******************this.props....')
        }
        */
       /*
        if (this.props.cruisesearch && this.props.cruisesearch.my_data && (this.props.cruisesearch.my_data.length > 0)) {
            my_data = this.props.cruisesearch.my_data
        } else if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
        }
        */
       /*svmar14 start*/
       let my_data_meta = {port:[]}
        if (this.props.cruisesearch && this.props.cruisesearch.my_data_meta && (this.props.cruisesearch.my_data_meta.port.length > 0)) {
            my_data_meta = this.props.cruisesearch.my_data_meta
        }else if(this.props.my_data_meta && (this.props.my_data_meta.port.length > 0)){
            my_data_meta = this.props.my_data_meta
        }else{
            my_data_meta ={port:[]}
        }
        console.log('svmar14***my_data_meta ')
        console.log(my_data_meta)
        console.log('svmar14***my_data_meta  end')
         /*svmar14 end*/
        // const {my_data_meta} = this.props.cruisesearch
        if (this.props.cruisesearch && this.props.cruisesearch.my_data && (this.props.cruisesearch.my_data.length > 0)) {
            my_data_tmp = this.props.cruisesearch.my_data
        }else if(this.props.my_data && (this.props.my_data.length > 0)){
            my_data_tmp = this.props.my_data
        }else{
            my_data_tmp = []
        }
       
        if (this.props.cruisesearch && this.props.cruisesearch.hasMore && (this.props.cruisesearch.hasMore != null )) {
            hasMore = this.props.cruisesearch.hasMore
        }else if(this.props.hasMore && (this.props.hasMore != null)){
            hasMore = this.props.hasMore
        }else{
            hasMore = true
        }
        console.log('sj***JUN13 this.props.sosjournsearch')
        console.log(this.props.cruisesearch)
        if (this.props.cruisesearch && (this.props.cruisesearch.ctotal > 0)) {
            ctotal = this.props.cruisesearch.ctotal
        }else if(this.props.ctotal && (this.props.ctotal != null)){
            ctotal = this.props.ctotal
        }else{
            ctotal = 2
        }
                       
       
        const {sv_esquery_data,my_scr_id} = this.props.cruisesearch
        console.log('SJ**SV****MAR7*invBoard*** GOT FACET DATA my_scr_id S', my_scr_id)
        console.log('sv_esquery_data***MUST**',sv_esquery_data)
        my_data = []
        for(let i=0; i < my_data_tmp.length ; i++ ){
            let r = my_data_tmp[i]
           
            /*sjmar7 
             let my_ob = _.clone(r)
            **/
            let my_ob = r

            /*sjmar7 end */
            my_data.push(my_ob)
            my_ob['svcustProfile'] = this.props.svcustProfile
            my_ob['customerId'] = customerId
        }

        let testimonyO = {
            avg_stars_rating: 5
        }
        return (
            <div className="svr-det-pageWrapper">
                <header className="svr-header1">
                    <h1><span><text style={{ color: '#f0d8a9' }}>Choose Your Cruise</text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                </header>
                <CliSearchBarBusCom my_data_meta={my_data_meta} />
                {/*  
                            <SojSearchBarBusCom />
                            
                           */}

                <div className="svr-spacelist-contentWrapper">
               
                    <article className="main-listcruises">
                         
                        <div className="svr-clislist-container">
                           
                          
                            { this.getBoardBodyContainer_cr(sjprobatecourtselectparent,my_data,svofferMyFlyReservationSelectparent,sjSHIPofferselectparent,ctotal,my_scr_id,svcli_esquery_data,cliAndImagesSojournMore,hasMore, sjcruiseselectparent, sjfarselectparent) }
                           

                        </div>
                    </article>




                </div>




                <br />


            </div>

        )
    }

    /*svdec17 */
    getChildContainersList_orgDetailSVWorkingCurrent() {

        const size = 'small'
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let customerId = -1
        let svCustomerId = -1
        const { dataProfile, svcustProfile } = this.props
        if (svcustProfile && svcustProfile.customerId > 0) {
            customerId = svcustProfile.customerId
            svCustomerId = customerId
            console.log('myreservationSpace')
        } else {
            console.log('internet userSpace')
        }
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []

        my_data = [
            {
                "code": "MI",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-14T00:00:00.000Z",
                    "arrivalDayOfWeek": "Thu",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-07T00:00:00.000Z",
                    "departureDayOfWeek": "Thu",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 0,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_SP_6_Mon",
                "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": true,
                "sailings": null,
                "shipCode": "MI",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            },
            {
                "code": "SP",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-12T00:00:00.000Z",
                    "arrivalDayOfWeek": "Tue",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-05T00:00:00.000Z",
                    "departureDayOfWeek": "Tue",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 809,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_SP_7_Tue_ols",
                "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalSpirit&format=image",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/spirit/7-days/ga2?itinportcode=SEA&sailDate=05052026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": false,
                "sailings": null,
                "shipCode": "SP",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            },
            {
                "code": "MI",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-14T00:00:00.000Z",
                    "arrivalDayOfWeek": "Thu",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-07T00:00:00.000Z",
                    "departureDayOfWeek": "Thu",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 829,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_MI_7_Thu",
                "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalMiracle&format=image",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&sailDate=05072026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": false,
                "sailings": null,
                "shipCode": "MI",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            },
            {
                "code": "SP",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-12T00:00:00.000Z",
                    "arrivalDayOfWeek": "Tue",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-05T00:00:00.000Z",
                    "departureDayOfWeek": "Tue",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 809,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_SP_7_Tue",
                "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalSpirit&format=image",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/spirit/7-days/ga2?itinportcode=SEA&sailDate=05052026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": false,
                "sailings": null,
                "shipCode": "SP",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            },
            {
                "code": "MI",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-14T00:00:00.000Z",
                    "arrivalDayOfWeek": "Thu",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-07T00:00:00.000Z",
                    "departureDayOfWeek": "Thu",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 829,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_MI_7_Thu",
                "image": "/service/GetItineraryRandomImage.aspx?RegionCode=GL&Key=7DaysGA2AlaskaInsidePassageGlacierCarnivalMiracle&format=image",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&sailDate=05072026&numGuests=2&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=True&locality=1&currency=USD&roomType=IS",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": false,
                "sailings": null,
                "shipCode": "MI",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            },
            {
                "code": "MI",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-14T00:00:00.000Z",
                    "arrivalDayOfWeek": "Thu",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-07T00:00:00.000Z",
                    "departureDayOfWeek": "Thu",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 0,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_SP_7_Tue_HW",
                "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "7-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": true,
                "sailings": null,
                "shipCode": "MI",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            },
            {
                "code": "MI",
                "departurePortCode": "SEA",
                "departurePortName": "Seattle, WA",
                "dur": 7,
                "duration": null,
                "exTrip": {
                    "arrivalDate": "2026-05-14T00:00:00.000Z",
                    "arrivalDayOfWeek": "Thu",
                    "arrivalDayOfWeekFull": null,
                    "arrivalMmmDYyyy": null,
                    "arrivalMmmDdYyyy": null,
                    "departureDate": "2026-05-07T00:00:00.000Z",
                    "departureDayOfWeek": "Thu",
                    "departureDayOfWeekFull": null,
                    "departureMmmDYyyy": null,
                    "departureMmmDdYyyy": null,
                    "embarkPortCode": "SEA",
                    "exSchedule": null,
                    "fromPrice": 0,
                    "fromPriceCurrency": "USD",
                    "leadMetaCode": "IS",
                    "taxesAndFees": 0
                },
                "hasExtraValue": true,
                "id": "GA2_SEA_SP_6_Mon_HW",
                "image": "/-/media/images/explore/destinations/ports/carnival-alaska-port-victoria-3.jpg?useCustomFunctions=1&centerCrop=1",
                "imageRandomizationInfo": null,
                "imageSquare": null,
                "imageUrl": null,
                "itineraryTitle": "31-Day Alaska Inside Passage & Glacier from Seattle, WA",
                "itineraryTitleFormatted": null,
                "itineraryURL": null,
                "itineraryURLWithSailing": "/itinerary/7-day-alaska-inside-passage-and-glacier-cruise/seattle/miracle/7-days/ga2?itinportcode=SEA&military=N&senior=N&pastGuest=N&evsel=&hideSailingEvents=true&locality=1&currency=USD",
                "portsToDisplay": null,
                "regionCode": "GL",
                "regionName": null,
                "roundtrip": true,
                "sailings": null,
                "shipCode": "MI",
                "shipName": null,
                "specialScoops": null,
                "stateroomMetaInformation": null,
                "taxesAndFeesRange": null
            }
        ]


        let testimonyO = {
            avg_stars_rating: 5
        }
        return (
            <div className="svr-det-pageWrapper">
                <header className="svr-header1">
                    <h1><span><text style={{ color: '#f0d8a9' }}>Choose Your Cruise</text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                </header>
                <CliSearchBarBusCom />

                {/*  
               
                <CliSearchBar></CliSearchBar>
                            <SojSearchBarBusCom />
                            
                           */}

                <div className="svr-spacelist-contentWrapper">
                    <article className="main-listcruises">
                        <div>SV**Cruise List Component here</div>
                        <div className="svr-clislist-container">

                            {this.getExDetailItins(my_data)}

                        </div>
                    </article>




                </div>




                <br />


            </div>

        )
    }



    getExDetailItins(my_data) {

        return (
            <CliDetailContainer></CliDetailContainer>
        )

    }
    /*sjmar6 start*/
    closecbParent(){
        let svCustomerId = this.props.svparams.id
      
        history.push(`/myreservationsSV/${svCustomerId}`)
      }
//getBoardBodyContainer_cr(my_data){
getBoardBodyContainer_cr(sjprobatecourtselectparent,my_data,svofferMyFlyReservationSelectparent,sjSHIPofferselectparent,ctotal,my_scr_id,svcli_esquery_data,cliAndImagesSojournMore,hasMore, sjcruiseselectparent,sjfarselectparent){
   
    if(this.props.cruisesearch.error){
        
        let errob = {
            "timestamp": "2026-03-05T02:27:18.038+0000",
            "status": 500,
            "error": "CruiseServer Error",
            "message": "No Resulst Found.Please refinse search and try again",
            "path": "/kk/svaddressDetailPost"
        }
        let today_dt = new Date()
        errob["timestamp"] = today_dt
       return (
         <div >
            
             <div style={{paddingTop:'10px'}}>
               <ErrorCom  closecbParent={this.closecbParent} errob={errob} ></ErrorCom>
             </div>
            
            
          </div>   
            )

      }else if(this.props.cruisesearch.loading === true ){
       
       return (

         <div >
            <h3>Spinner*****</h3>
         <div style={{paddingTop:'10px'}}>
        

           <SVAbodeSpinner />
         </div>
        
        
      </div>   

       
             )

      }
    /*
      if (this.props.loading) {
return <Loader type='spinner' />
} else if (this.props.error) {
return <ErrorWidget error={this.props.error} />
}

 return this.getExBottles(my_data)  
 */
 return (
         
       
         
                   
                  
    <CliSJScroll 
    ctotal={ctotal} 
    my_scr_id={my_scr_id} 
    svcli_esquery_data={svcli_esquery_data}  
    my_data={my_data} 
    cliAndImagesSojournMore={cliAndImagesSojournMore} 
    hasMore={hasMore} 
    sjSHIPofferselectparent={sjSHIPofferselectparent} 
    sjcruiseselectparent={sjcruiseselectparent} 
    sjfarselectparent = {sjfarselectparent}
    sjprobatecourtselectparent={sjprobatecourtselectparent} ></CliSJScroll>
                   
)

}
/*sjamr6 end*/

/*svjul17 start */

getContainer_stateroom_old(){
    return (
        <div className="col-md-12" id="svsr1">

            <div class="carousel-wrapper">
    <button class="carousel-button prev" onclick="moveCarousel(-1)">
      &#10094;
    </button>

    <div class="carousel-track" id="carouselTrack">

      <div class="carousel-box">
        <h3>Box One</h3>
        <p>
          This is the paragraph content for the first carousel box.
        </p>
      </div>

      <div class="carousel-box">
        <h3>Box Two</h3>
        <p>
          This is the paragraph content for the second carousel box.
        </p>
      </div>

      <div class="carousel-box">
        <h3>Box Three</h3>
        <p>
          This is the paragraph content for the third carousel box.
        </p>
      </div>

      <div class="carousel-box">
        <h3>Box Four</h3>
        <p>
          This is the paragraph content for the fourth carousel box.
        </p>
      </div>

      <div class="carousel-box">
        <h3>Box Five</h3>
        <p>
          This is the paragraph content for the fifth carousel box.
        </p>
      </div>

      <div class="carousel-box">
        <h3>Box Six</h3>
        <p>
          Additional boxes can be added and viewed using the arrows.
        </p>
      </div>

    </div>

    <button class="carousel-button next" onclick="moveCarousel(1)">
      &#10095;
    </button>
  </div>
        </div>
    )


}
/*
getContainer_stateroom(){
    return (  <div className="col-md-12" id="svsr1">
                <SRCarousel></SRCarousel>
              </div>
        )
}
*/
sjfarselectparent(valuesChild,soj_rate_key ){
    let me = this
  
  let spaceKey = valuesChild['spaceKey']
 
  const { cookies } = this.props;
 
  if(cookies){
      let sjcookoffer_o = null
      console.log('********OCT25**************** sv  OCT28 2 COOKIES SET sjcookoffer START')

      if(valuesChild ){
            console.log('********NOV19**************** sv START ')
        let sjcookoffer_val = {}
        
          
          let svcustProfile_newcustomer = {
            "customerId": -6,
            "addressId":-1
        }
        //room selection is first room . UI screen for roomtype selection needed
        let svvc = {}
        let asset = valuesChild.offer
       
        const {departurePortCode, id, excursionId} = valuesChild.offer
       
       
       
        let obroom = {
            "code":asset.id,
            "excursionId" : excursionId,
            "name":asset.departurePortCode,
            rates: []
        }
        obroom.rates.push(departurePortCode)

       

         let ratekey = asset.id 
         svvc.rateKey = id
         svvc.code =asset.id
         svvc.reviews =''
         svvc.room = obroom
         svvc.svrate= asset.id
        // svvc.svrate= asset.exTrip
        
         svvc.svcustProfile = svcustProfile_newcustomer
         if(!valuesChild['svcustProfile']){
            valuesChild['svcustProfile'] = svcustProfile_newcustomer
         }

         let svaluesChild = JSON.stringify(svvc)
         let size = svaluesChild.length
         
         
          

        
          try{
            
            cookies.set('sccook', svaluesChild, { path: '/' });

          }catch(error){
            console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')

               console.log(error)}
         

          let m_offer = cookies.get('sccook')
          
          let my_data_sjtoffee ={
            "customerId": valuesChild['svcustProfile']['customerId'] ,
            "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
            "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
        } 
        my_data_sjtoffee.sjcook = svaluesChild
       
        let expsessid_svt_s =  cookies.get('svabodeclientguest')
        
        
        let m_svt = expsessid_svt_s
        if(m_svt != null){
            my_data_sjtoffee['svt'] = m_svt
        }
        
          
       
        const udob ={
            "svcid": -2,
            "soj_rate_key":id,
            "code": id ,
            "excursionId" : excursionId,
            "room": obroom
            
        
        }

      
        _.delay(()=>{
            
            
             const { soj_rate_key} = udob
             
             const { code, excursionId} = udob
            
             let surl = `/inetcruises/svredsr/${code}`
          
            history.push(`/inetcruises/svredsr/${excursionId}`)
            
               }, 400, udob);

        // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)

      }else{
          console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer ** FARE ** svedsr failes START')

      }
      

  }

}
/*svjul17 end*/

}

export default CliSearchBoardContainer